import script from "./MemberJoinView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberJoinView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__